'use client';
import type { AppProps } from 'next/app';
import { useEffect } from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import '@/styles/tailwind.css';
import { validateAndSyncLocalStorage } from '@/lib/storageValidator';

import { Providers } from '@/providers';
import AuthenticatedReportBugButton from '@/shared/Button/AuthenticatedReportBugButton';

function AppWithSessionTimeout({ Component, pageProps }: AppProps) {
    useSessionTimeout();
    return (
        <>
            <Component {...pageProps} />
            {process.env.ARM_SERVER === 'DEV' && <AuthenticatedReportBugButton />}
        </>
    );
}

function MyApp(props: AppProps) {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            validateAndSyncLocalStorage();
        }
    }, []);
    return (
        <Providers>
            <AppWithSessionTimeout {...props} />
        </Providers>
    );
}

export default MyApp;
